module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/a0108-person/a-yoyaku-memo-modal.component.css
// module id = ./src/app/a0108-person/a-yoyaku-memo-modal.component.css
// module chunks = main